// extracted by mini-css-extract-plugin
module.exports = {"popup":"Notification_popup__13jOd","popupInner":"Notification_popupInner__JAzwJ"};